define('ShippingCountdown.View', [
  'underscore',
  'SCView',
  'shipping_countdown.tpl'
], function ShippingCountdownViewModule(_, SCViewComponent, shippingCountdownTpl) {
  'use strict';

  var intervalTime = 60 * 1000;

  var SCView = SCViewComponent.SCView;

  function ShippingCountdownView(options) {
    SCView.call(this, options);
    this.template = shippingCountdownTpl;
    this.model = options.model;

    this.setupCountdownInterval();
    this.setupListeners();
  }

  ShippingCountdownView.prototype = Object.create(SCView.prototype);

  _.extend(ShippingCountdownView.prototype, {
    constructor: ShippingCountdownView,

    destroy: function destroy() {
      this.unsetCountdownInterval();
      this.unsetListeners();
    },

    setupCountdownInterval: function setupCountdownInterval() {
      var self = this;
      var model = this.model;
      var environment = model.container.getComponent('Environment');
      if (environment.isPageGenerator()) {
        return;
      }
      this.countdownInterval = setInterval(function callback() {
        if (!self.isLoaded()) {
          return;
        }
        self.render();
      }, intervalTime);
    },

    unsetCountdownInterval: function unsetCountdownInterval() {
      if (!this.countdownInterval) {
        return;
      }
      clearInterval(this.countdownInterval);
    },

    setupListeners: function setupListeners() {
      var self = this;
      this.model.getLocations().on(
        'sync',
        function listenLocationsChange() {
          self.render();
        },
        this
      );
    },

    unsetListeners: function unsetListeners() {
      this.model.getLocations().off('sync', null, this);
    },

    isLoaded: function isLoaded() {
      var model = this.model;
      var isLoading = model.isLoading();
      var shouldShow = model.shouldShow();
      return !isLoading && shouldShow;
    },

    getContext: function getContext() {
      var model = this.model;
      var isLoaded = this.isLoaded();
      var context = {
        isLoading: model.isLoading(),
        shouldShow: model.shouldShow()
      };
      return _.extend(context, isLoaded ? this.getContextLoaded() : {});
    },

    getContextLoaded: function getContextLoaded() {
      var model = this.model;
      var location = model.getLocations().getFastestShippingLocation();
      var cutOffTimeStatus;
      var estimatedShippingMin;
      var shippingDay;
      var countdownTimer;
      var deliveredBy;
      if (!location) {
        return { shouldShow: false };
      }
      cutOffTimeStatus = location.getCutOffTimeStatus();
      estimatedShippingMin = location.getEstimatedShippingMin();
      if (!cutOffTimeStatus) {
        return { shouldShow: false };
      }

      deliveredBy = estimatedShippingMin ? estimatedShippingMin.moment.format('dddd, MMMM Do') : '';
      countdownTimer = cutOffTimeStatus.difference.format('h [hrs] m [min]');
      if (cutOffTimeStatus.isToday) {
        shippingDay = 'today';
      } else if (cutOffTimeStatus.isTomorrow) {
        shippingDay = 'tomorrow';
      } else {
        shippingDay = cutOffTimeStatus.moment.format('dddd');
        countdownTimer = cutOffTimeStatus.difference.format('d [days] h [hrs] m [min]');
      }

      return {
        shippingDay: shippingDay,
        deliveredBy: deliveredBy,
        countdownTimer: countdownTimer
      };
    }
  });

  return ShippingCountdownView;
});
